import React from 'react';

import { PDFDocument } from 'Components/PDFDocument';
import { PDFMetadata } from 'Interfaces/Common';
import { DocumentField } from 'Interfaces/DocumentFields';

import DocumentNavigationItem from './DocumentNavigationItem';

interface InteractNavigationProps {
  documents: string[];
  pages: Record<string, number[]>;
  pagesMeta: PDFMetadata;
  totalPages: number;
  isLoaded: boolean;
  onGetFields: (documentFileIdx: number, pageNumber: number) => DocumentField[];
  onNavigate: (documentFileIds: number, pageNumber: number) => void;
}

const InteractNavigation = ({
  documents,
  pages,
  pagesMeta,
  totalPages,
  isLoaded,
  onGetFields,
  onNavigate,
}: InteractNavigationProps) => {
  let pdfDocumentFilesCount = 0;

  return (
    <div className="interactModal__documentNavigation-wrapper">
      <p className="interactModal__documentNavigation-title">
        Pages <span>({totalPages})</span>
      </p>
      <ul className="interactModal__documentNavigation">
        {documents.map((pdfDocumentFile, pdfDocumentFileIdx) => (
          <PDFDocument file={pdfDocumentFile} key={pdfDocumentFile}>
            {isLoaded &&
              pages[pdfDocumentFile].map(pageNumber => (
                <DocumentNavigationItem
                  key={pageNumber}
                  pageNumber={pageNumber}
                  pageMeta={pagesMeta[++pdfDocumentFilesCount]}
                  fields={onGetFields(pdfDocumentFileIdx, pageNumber)}
                  navigateToPage={() => onNavigate(pdfDocumentFileIdx, pageNumber)}
                />
              ))}
          </PDFDocument>
        ))}
      </ul>
    </div>
  );
};

export default InteractNavigation;
